import { Component, ViewEncapsulation } from '@angular/core';
import { DownloadService, LifecycleAware } from '@lsq-frontend/common-ui';
import { ClaimService } from '@lsq-frontend/common-ui';
import { ErrorToastBlacklistService } from '@lsq-frontend/angular-shared/features/error-toast-blacklist-service';
import { GeneratePresignedUrlForBuyerService } from '@lsq-frontend/remote-services/all-java/financing-mk0-services';
import { GeneratePresignedUrlForBuyerAccountService } from '@lsq-frontend/remote-services/all-java/financing-mk0-services';
import { GetBuyerAccountUploadTemplateService } from '@lsq-frontend/remote-services/all-java/financing-mk0-services';
import { GetBuyerUploadTemplateService } from '@lsq-frontend/remote-services/all-java/financing-mk0-services';
import { ImportS3ForBuyerAccountOnlyService } from '@lsq-frontend/remote-services/all-java/financing-mk0-services';
import { ImportS3ForBuyerOnlyService } from '@lsq-frontend/remote-services/all-java/financing-mk0-services';
import { GeneratePresignedUrlForBuyerAccountRequest } from '@lsq-frontend/remote-services/all-java/financing-mk0-services';
import { GetBuyerAccountUploadTemplateRequest } from '@lsq-frontend/remote-services/all-java/financing-mk0-services';
import { TemplateType } from '@lsq-frontend/remote-services/all-java/financing-mk0-services';
import { UploadType } from '@lsq-frontend/remote-services/all-java/financing-mk0-services';
import { ModalWorkflowService } from '@lsq-frontend/common-ui';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { BuyerAccountUploadModalComponent } from './buyer-account-upload-modal.component';

@LifecycleAware()
@Component({
    selector: 'buyer-account-invoice-upload-modal',
    templateUrl: './buyer-account-upload-modal.component.html',
    styleUrls: ['./buyer-account-upload-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class BuyerAccountInvoiceUploadModalComponent extends BuyerAccountUploadModalComponent {
    constructor(
        protected _getBuyerAccountUploadTemplateService: GetBuyerAccountUploadTemplateService,
        protected _getBuyerUploadTemplateService: GetBuyerUploadTemplateService,
        protected _generatePresignedUrlService: GeneratePresignedUrlForBuyerAccountService,
        protected _generatePresignedBuyerUrlService: GeneratePresignedUrlForBuyerService,
        protected _importS3ForBuyerAccountOnlyService: ImportS3ForBuyerAccountOnlyService,
        protected _importS3ForBuyerOnlyService: ImportS3ForBuyerOnlyService,
        protected _downloadService: DownloadService,
        protected _modalWorkflowService: ModalWorkflowService,
        protected _errorToastBlacklistService: ErrorToastBlacklistService,
        protected _i18n: I18n,
        protected _claimService: ClaimService
    ) {
        super(
            _getBuyerAccountUploadTemplateService,
            _getBuyerUploadTemplateService,
            _generatePresignedUrlService,
            _generatePresignedBuyerUrlService,
            _importS3ForBuyerAccountOnlyService,
            _importS3ForBuyerOnlyService,
            _downloadService,
            _modalWorkflowService,
            _errorToastBlacklistService,
            _claimService,
            _i18n
        );
        this.setFileName('Invoice');
        this.setGetUploadTemplateRequest(
            new GetBuyerAccountUploadTemplateRequest({ templateType: TemplateType.INVOICE })
        );
        this.setGetPresignedUrlRequest(
            new GeneratePresignedUrlForBuyerAccountRequest({ uploadType: UploadType.INVOICE })
        );
    }
}
